import cx from 'classnames';
import {useMemo} from 'react';

type Props = {
    value: number;
    className?: string;
    color?: 'primary' | 'alert';
}

export const LinearProgress: React.FC<Props> = ({value, color = 'alert', className}: Props) => {
    const colorClassName = useMemo(() => {
        if (color === 'alert') {
            return 'tw-bg-alert';
        } else if (color === 'primary') {
            return 'tw-bg-primary';
        }
        return [];
    }, [color]);

    const normalizedValue = useMemo(() => {
        if (value < 0) {
            return 0;
        } else if (value > 100) {
            return 100;
        }
        return value;
    }, [value]);

    return (
        <div className={cx('tw-relative tw-w-full tw-h-1', className)}>
            <div className={cx('tw-h-full tw-bg-opacity-30', colorClassName)} />
            <div
                style={{width: `${normalizedValue}%`}}
                className={cx('tw-h-full tw-absolute tw-inset-0 tw-transition-width tw-duration-500', colorClassName)}
            />
        </div>
    );
};
